import React, {useState} from "react";
import isEmpty from "is-empty";
import {Collapse} from "@mui/material";
import Svg from "@/Components/Svg";
import reachGoalYM from "@/Helpers/ReachGoalYM";
import reachGoalGA from "@/Helpers/ReachGoalGA";
import Link from "@/Layouts/Link";
import "@/Scss/Site/Product/aboutDecoration.scss";

const AboutDecoration = (props) => {
    const {product = {}, productDataCurrent = {}, isMobile} = props;
    const {aboutDecorationData = []} = product;
    const {
        article = '',
        category = '',
        categoryAlias = '',
        metal = '',
        metalAlias = '',
        productMetal = '',
        productWidth = '',
        collection = '',
        collectionAlias = '',
        coating = '',
    } = product;

    const [accordionState, setAccordionState] = useState(() => {
        return aboutDecorationData.reduce((acc, el, i) => {
            acc[i] = !!el.state;
            return acc;
        }, {});
    });
    const [insertsState, setInsertsState] = useState(false);

    const toggleAccordion = (index) => {
        setAccordionState(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    // Количество символов для вставок
    let numberCharacters = 45;
    if (isMobile) {
        numberCharacters = 25;
    }
    let insertsDetailsText = !isEmpty(productDataCurrent) ? productDataCurrent.insert_details : '';
    const insertsDetailsColumn = insertsDetailsText
        ? insertsDetailsText.split(';').map((el, i) => <div key={i}>{el}</div>)
        : [];

    return (
        <div id={`about-decoration`} className={`aboutDecoration`}>
            <p className={`aboutDecoration__title`}>Об украшении</p>
            <div className={`aboutDecoration__body`}>
                <div className={`aboutDecoration__productInfoContainer`}>
                    {!isEmpty(category) && (
                        <Link href={`/catalog/${categoryAlias}`} className={`aboutDecoration__productInfoItem`}>
                            <span className={`left`}>Вид изделия</span>
                            <span className={`right collection`}>{category}</span>
                        </Link>
                    )}
                    {(!isEmpty(metal) || !isEmpty(productMetal)) && (
                        <Link href={`/catalog/${categoryAlias}/${metalAlias}`}
                              className={`aboutDecoration__productInfoItem`}>
                            <span className={`left`}>Металл</span>
                            {!isEmpty(productMetal)
                                ? <span className={`right collection`}>{productMetal}</span>
                                : <span className={`right collection`}>{metal}</span>
                            }
                        </Link>
                    )}
                    {!isEmpty(article) && (
                        <div className={`aboutDecoration__productInfoItem`}>
                            <span className={`left`}>Артикул</span>
                            <span className={`right`}>{article}</span>
                        </div>
                    )}
                    {!isEmpty(insertsDetailsText) && (
                        <div className={`aboutDecoration__productInfoItem`}>
                            <div className={`left`}>Вставка</div>
                            <div className={`right right__column`}>
                                <Collapse in={insertsState} collapsedSize={20}>
                                    {insertsDetailsColumn}
                                </Collapse>
                                {(insertsDetailsText.length > numberCharacters) && (
                                    <div className={`aboutDecoration__moreDetailed`}
                                         onClick={() => setInsertsState(!insertsState)}>
                                        {insertsState ? 'Скрыть' : 'Подробнее'}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    {(!isEmpty(productDataCurrent) && !isEmpty(Number(productDataCurrent.ves))) && (
                        <div className={`aboutDecoration__productInfoItem`}>
                            <span className={`left`}>Средняя масса</span>
                            <span className={`right`}>{productDataCurrent.ves} г</span>
                        </div>
                    )}
                    {!isEmpty(coating) && (
                        <div className={`aboutDecoration__productInfoItem`}>
                            <span className={`left`}>Покрытие</span>
                            <span className={`right`}>{coating}</span>
                        </div>
                    )}
                    {!isEmpty(productWidth) && (
                        <div className={`aboutDecoration__productInfoItem`}>
                            <span className={`left`}>Ширина</span>
                            <span className={`right`}>{productWidth} мм</span>
                        </div>
                    )}
                    {!isEmpty(collection) && (
                        <Link href={`/catalog/${collectionAlias}`} className={`aboutDecoration__productInfoItem`}>
                            <span className={`left`}>Коллекция</span>
                            <span className={`right collection`}>{collection}</span>
                        </Link>
                    )}
                    <div className={`aboutDecoration__productSpecifications product-info__specifications`}>
                        В редких случаях характеристики изделия или упаковка могут иметь отличия от
                        представленных на фото или в описании. Стоимость ювелирного изделия указана в рублях за единицу
                        Товара без учета стоимости его доставки и включает НДС. Окончательная стоимость Товара
                        формируется
                        после регистрации покупателя, оформления заказа и указания региона (населенного пункта) доставки
                        в
                        соответствии с Приложением №2 к договору оферты.
                    </div>
                </div>
                <div id={`product__accordion`} className={`aboutDecoration__accordion`}>
                    {aboutDecorationData.map((el, i) => {
                        const {title = '', description = '', link = ''} = el;

                        return <div key={i} className={`aboutDecoration__accordionItem`}>
                            <div className={`aboutDecoration__accordionHeader`} onClick={() => toggleAccordion(i)}>
                                <p className={`aboutDecoration__accordionTitle`}>{title}</p>
                                <div className={`aboutDecoration__accordionArrowContainer`}>
                                    <Svg id={`arrows-down`}
                                         className={`svg__productAboutDecorationArrow${accordionState[i] ? ' svg__productAboutDecorationArrow_up' : ''}`} />
                                </div>
                            </div>
                            <div
                                className={`aboutDecoration__accordionDescriptionContainer${accordionState[i] ? ' visible' : ''}`}>
                                <div className={`aboutDecoration__accordionDescription`}>
                                    <div dangerouslySetInnerHTML={{__html: description}}></div>
                                    {!isEmpty(link) && (
                                        <Link href={link} className={`link link__aboutDecoration`}>
                                            Подробнее
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    })}
                </div>
            </div>
            <div className={`aboutDecoration__contactsContainer`}>
                <div className={`aboutDecoration__questions`}>
                    <p className={`aboutDecoration__question`}>Возникли вопросы?</p>
                    <p className={`aboutDecoration__questionDesc`}>Свяжитесь с нами</p>
                </div>
                <div className={`aboutDecoration__phoneContainer`}>
                    <a
                        onClick={() => {
                            reachGoalYM('phone_click');
                            reachGoalGA('phone_click');
                        }}
                        href={`tel:+79109522022`}
                        className={`aboutDecoration__phoneNumber`}
                    >
                        8 910 952-20-22
                    </a>
                </div>
                <div className={`aboutDecoration__socials`}>
                    <a href={`https://max.ru/u/f9LHodD0cOJrp9GGSadyrX__BRbqLq0CqQSijuZcF41L_Qe3TmiNWDBVbX4`}
                       target="_blank"
                       className={`aboutDecoration__max`}>
                        <Svg id={`max`} className={`svg--maxProduct`} />
                    </a>
                    {/*<a href={`https://t.me/platina_jewelry_chat`}*/}
                    <a href={`https://t.me/PlatinaManagerBot`}
                       target="_blank"
                       className={`aboutDecoration__telegram`}>
                        <Svg id={`telegram`} className={`svg--telegramProduct`} />
                    </a>
                    {/*<a href={`https://wa.me/79109522022`}*/}
                    {/*   target="_blank"*/}
                    {/*   className={`phone-box__whatsapp phone-box__whatsapp_product`}>*/}
                    {/*    <Svg id={`whatsapp`} className={`svg__whatsapp svg__whatsapp_product`} />*/}
                    {/*</a>*/}
                    {/*<a href={`viber://chat?number=%2B79109522022`}*/}
                    {/*   target="_blank"*/}
                    {/*   className={`phone-box__viber phone-box__viber_product`}>*/}
                    {/*    <Svg id={`viber`} className={`svg__viber svg__viber_product`} />*/}
                    {/*</a>*/}
                </div>
            </div>
        </div>
    );
};

export default AboutDecoration;
